import { TypePageTexts } from '@/types/i18n';
import en from './en/index.json';
export const PageTexts: TypePageTexts = {
  en,
};
